module.exports = __webpack_public_path__ + "static/images/welfare-img.45c9924.png";